import { endPoints } from 'api/';
import { UPDATE_ORDER_SETTINGS } from 'actions/types';

/**
 * @description Updates setting object
 * @param {Object} payload
 * @param {string} id
 * @returns Setting object
 */
export function updateOrderSetting(id, payload) {
  /**
   * @param {Function} dispatch
   */
  return function (dispatch) {
    const action = {
      type: UPDATE_ORDER_SETTINGS,
      /**
       * @param {Function} apiClient
       */
      request: async function (apiClient) {
        return await apiClient(endPoints.UPDATE_ORDER_SETTINGS, payload, id);
      },
    };
    dispatch(action);
  };
}
